import { PrescriptionListItemViewModel } from '../../views/Prescription/ViewModels/PrescriptionListItemViewModel';

export async function paginate({ page, limit, filter: { search, providerStatus, patientStatus }, sort }) {
  const res = await window.axios({
    method: 'GET',
    baseURL: process.env.VUE_APP_EPRES_ENDPOINT,
    url: 'admin/prescription',
    params: {
      page,
      limit,
      'filter.search': search,
      'filter.providerStatus': providerStatus,
      'filter.patientStatus': patientStatus,
      'sort.by': sort ? sort.by : undefined,
      'sort.order': sort ? sort.order : undefined,
    },
  });
  /**
   * res.data
   *
   * limit - limit the result return
   * page - page number as requested
   * total - total number of pages
   * data - list of prescriptions
   */

  res.data.data.data = res.data.data.data.map((prescription) => new PrescriptionListItemViewModel(prescription));

  return res.data.data;
}
